export const CAMERA_ATTEMPTS = 3;
export const RETRY_MS = 160;

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const attemptsFor = (source) => (source?.videoWidth ? CAMERA_ATTEMPTS : 1);

export async function findDog(detector, source, { attempts = 1, delay = RETRY_MS, onError = () => {}, wait = pause } = {}) {
  let detection = null;
  for (let attempt = 0; attempt < Math.max(1, attempts); attempt += 1) {
    detection = await detector.find(source, onError);
    if (!detection || detection.dogs.length) return detection;
    if (attempt + 1 < attempts) await wait(delay);
  }
  return detection;
}
